import styled from "styled-components";

// Common section wrapper
export const SectionWrapper = styled.div`
  background: ${({ theme }) => theme.semanticColors.bodyStandoutBackground};
  border: 1px solid ${({ theme }) => theme.semanticColors.bodyFrameDivider};
  border-radius: 8px;
  padding: 22px;
  margin-bottom: 12px;
`;

// Common section title
export const SectionTitle = styled.h3`
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.semanticColors.bodyText};
`;

// Grid layouts
export const ProposalDataGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 12px 16px;
  align-items: center;

  //   @media (max-width: 1200px) {
  //     grid-template-columns: 1fr 1fr 1fr 1fr;
  //     gap: 8px 12px;
  //   }

  //   @media (max-width: 768px) {
  //     grid-template-columns: 1fr 1fr;
  //     gap: 8px;
  //   }
`;

export const VehicleDataGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 12px 16px;
  align-items: center;

  //   @media (max-width: 1200px) {
  //     grid-template-columns: 1fr 1fr 1fr 1fr;
  //     gap: 8px 12px;
  //   }

  //   @media (max-width: 768px) {
  //     grid-template-columns: 1fr 1fr;
  //     gap: 8px;
  //   }
`;

export const CompactGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px 12px;
  align-items: center;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

// Updated styling to match offer page dropdowns exactly
export const CompactField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  /* Remove all custom dropdown styling to match offer page */
  .fui-Dropdown {
    min-width: unset !important;
    width: 100% !important;
    border: none !important; /* Remove conflicting borders */
  }

  .fui-Dropdown__listbox {
    min-width: unset !important;
    width: 100% !important;
  }

  /* Ensure dropdown button has clean styling like offer page */
  .fui-Dropdown__button {
    border: 1px solid
      ${({ theme }) =>
        theme.isDark
          ? "rgba(255, 255, 255, 0.1)"
          : "rgba(0, 0, 0, 0.12)"} !important;
    border-radius: 4px !important;
    box-shadow: none !important;
    background: ${({ theme }) =>
      theme.semanticColors.inputBackground} !important;
  }

  .fui-Dropdown__button:hover {
    border-color: ${({ theme }) =>
      theme.isDark
        ? "rgba(255, 255, 255, 0.15)"
        : "rgba(0, 0, 0, 0.18)"} !important;
  }

  .fui-Dropdown__button:focus {
    border-color: ${({ theme }) => theme.semanticColors.link} !important;
    box-shadow: 0 0 0 2px
      ${({ theme }) =>
        theme.isDark
          ? "rgba(56, 169, 255, 0.2)"
          : "rgba(0, 120, 212, 0.2)"} !important;
  }
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  justify-self: center;
  align-self: end; /* Align to bottom of grid cell like other inputs */
  transform: translateY(
    4px
  ); /* Move checkbox up to align with input content, accounting for input border/padding */
`;

export const MarginTop = styled.div`
  margin-top: 12px;
`;

export const MaxWidth = styled.div`
  max-width: 300px;
`;

export const SpanTwo = styled.div`
  grid-column: span 2;
`;

export const SpanThree = styled.div`
  grid-column: span 3;
`;
